import { fetcher } from "utils/axios";

export const createMarket = async ({ payload }) => {
  const response = await fetcher.post(`/admin/market`, payload);

  if (response.status === 200) {
    return response.data.data;
  }

  throw new Error(response.data.message);
};

export const getMarkets = async ({ queryKey }) => {
  const [, params] = queryKey;
  const response = await fetcher(`/admin/market/list`, { params });

  if (response.status === 200) {
    return response.data.data;
  }

  throw new Error(response.data.message);
};

export const getMarket = async ({ id }) => {
  const response = await fetcher(`/admin/market/${id}`);

  if (response.status === 200) {
    return response.data.data;
  }

  throw new Error(response.data.message);
};

export const updateMarket = async ({ id, payload }) => {
  const response = await fetcher.put(`/admin/market/${id}`, payload);

  if (response.status === 200) {
    return response.data.data;
  }

  throw new Error(response.data.message);
};

export const deleteMarket = async ({ id }) => {
  const response = await fetcher.delete(`/admin/market/${id}`);

  if (response.status === 200) {
    return response.data.data;
  }

  throw new Error(response.data.message);
};
